import * as amplitude from '@amplitude/analytics-browser';
import { useEffect } from 'react';

export const useAmplitudePageViewed = (pathname: string) => {
  const pathnameSplit = pathname.split('/')[2];

  useEffect(() => {
    if (pathnameSplit) {
      amplitude.logEvent('Page Viewed', {
        page_pathname: pathnameSplit,
      });
    }
  }, [pathnameSplit]);
};
